import { Link } from 'react-router-dom'
import type { ManagerEvent, ManagerEventType } from './types'

// Цветные точки слева — единственный визуальный маркер типа события.
// Раньше дублировались через emoji 🟢🔵🟣🟡, что выбивалось из общего
// дизайна остальных блоков дашборда (TopBrands, ActiveRequests —
// без emoji). Сергей попросил привести к общему стилю 28.04.
const EVENT_DOT: Record<ManagerEventType, string> = {
  quote_created: 'bg-emerald-500',
  request_created: 'bg-blue-500',
  request_status_changed: 'bg-purple-500',
  quotes_ready: 'bg-emerald-500',
  comment_created: 'bg-amber-500',
}

function timeAgo(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime()
  const sec = Math.max(0, Math.floor(diffMs / 1000))
  if (sec < 60) return `${sec} сек назад`
  const min = Math.floor(sec / 60)
  if (min < 60) return `${min} мин назад`
  const h = Math.floor(min / 60)
  if (h < 24) return `${h} ч назад`
  const d = Math.floor(h / 24)
  return `${d} д. назад`
}

export function EventsFeed({ events }: { events: ManagerEvent[] }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="text-sm text-gray-500 mb-3">Лента событий</div>

      {events.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Пока событий нет</p>
      ) : (
        <ul className="space-y-1 overflow-y-auto max-h-[360px] pr-1">
          {events.map((e) => (
            <li key={e.id}>
              <Link
                to={`/requests/${e.requestId}`}
                className="block hover:bg-gray-50 rounded-lg px-2 py-1.5 transition-colors"
              >
                <div className="flex items-start gap-2.5">
                  <span className={`w-2 h-2 rounded-full mt-1.5 shrink-0 ${EVENT_DOT[e.type]}`} />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm text-gray-800 leading-snug">{e.message}</div>
                    <div className="text-xs text-gray-400 mt-0.5 flex items-center gap-1.5">
                      {e.requestNumber && (
                        <>
                          <span className="font-mono text-gray-500">{e.requestNumber}</span>
                          <span className="text-gray-300">·</span>
                        </>
                      )}
                      <span>{timeAgo(e.createdAt)}</span>
                    </div>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
